import React from "react";
import GithubContributionCalendar from "../GithubContributionCalendar";
import { GITHUB_USERNAME } from "../../constants/github";

/**
 * GitHub contribution graph (uses a working public API; the old
 * react-github-calendar Heroku proxy returns 404 → "Error :(").
 */
function HomeGithubHeatmap({ username = GITHUB_USERNAME }) {
  return (
    <div className="home-github-heatmap-chart">
      <GithubContributionCalendar
        username={username}
        blockSize={10}
        blockMargin={3}
        showTotalCount
      />
    </div>
  );
}

export default HomeGithubHeatmap;
